export interface GlobalNotifPositionInput {
  readonly pointerX: number;
  readonly pointerY: number;
  readonly width: number;
  readonly height: number;
  readonly viewportWidth: number;
  readonly viewportHeight: number;
  readonly offset?: number;
  readonly edgeGap?: number;
}

export const getGlobalNotifPosition = ({
  pointerX,
  pointerY,
  width,
  height,
  viewportWidth,
  viewportHeight,
  offset = 20,
  edgeGap = 8,
}: GlobalNotifPositionInput) => {
  const maxX = Math.max(edgeGap, viewportWidth - width - edgeGap);
  const maxY = Math.max(edgeGap, viewportHeight - height - edgeGap);
  const preferredX = pointerX + offset;
  const preferredY = pointerY;

  return {
    x: Math.min(Math.max(preferredX, edgeGap), maxX),
    y: Math.min(Math.max(preferredY, edgeGap), maxY),
  };
};
